<template>
  <sTooltip
    :border="false"
    :open-delay="300"
    placement="bottom"
    popper-class="draft-bid-tooltip info-tooltip"
    type="white">
    <div
      class="draft-bid h9-text d-flex align-center justify-center rounded-xl px-2 py-1 "
      data-qa="draft-bid">
      {{ $t('Purchasing.Draft') }}
    </div>
    <template #content>
      <div
        class="h7-text black--text ma-2"/>
      <div>{{ $t('Tenders.BidDraftTooltipTextLine1', {old_tender}) }}</div>
      <div>{{ $t('Tenders.BidDraftTooltipTextLine2') }}</div>
    </template>
  </sTooltip>
</template>
<script>
export default {
  name: 'draftBidChip',
  props: {
    old_tender: {
      type: String,
      default: 'old_tender'
    }
  }
}
</script>
<style lang="scss" scoped>
.draft-bid {
  background: #C4C4C4;
}
</style>
<style lang="scss">
.draft-bid-tooltip.info-tooltip {
  max-width: 440px;
}
</style>
